module.exports = __webpack_public_path__ + "img/asus_pic3.20f39210.png";